module["exports"] = [
  "CH",
  "CH",
  "CH",
  "DE",
  "AT",
  "US",
  "LI",
  "US",
  "HK",
  "VN"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/address/country_code.js
// module id = 1362
// module chunks = 0